import React, { Component } from "react";
import moment from "moment";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import colors from "../../common/Colors";
import routes from "../../routes/URL";
import Table from "../../components/Table";

class CreateScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "active", // 'active' or 'closed'
      data: null,
    };
  }

  componentDidMount() {

    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root);
      return;
    }
    this.fetchData();
  }

  fetchData = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.getAllActiveTickets
    );

    if (status === "success") {
      this.setState({ data });
    }
  };
  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
    // Update URL to reflect the current tab
    this.props.history.push(
      routes.admin.support.root(this.props.match.params.hotelSlug, tab)
    );
  };

  render() {
    const { activeTab } = this.state;

    return (
      <div className="container-fluid MuiBox-root css-0">
        {/* heading */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <h1>My Support Tickets</h1>
          <div
            className="btn"
            onClick={() => {
              this.props.history.push(routes.admin.support.create(this.props.hotels[0]?.hotel_slug || ''));
            }}
            style={{
              backgroundColor: colors.primary,
              color: "black",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >

            NEW TICKET
          </div>
        </div>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            margin: "20px 0px",

          }}
        >
          <div
            onClick={() => this.handleTabChange("active")}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              borderBottom: `3px solid ${activeTab === "active" ? colors.primary : "transparent"
                }`,
              fontWeight: activeTab === "active" ? "bold" : "normal",
              color: activeTab === "active" ? colors.primary : "white",
              transition: "all 0.3s ease",
            }}
          >
            Active Tickets
          </div>
          <div
            onClick={() => this.handleTabChange("closed")}
            style={{
              padding: "10px 20px",
              cursor: "pointer",
              borderBottom: `3px solid ${activeTab === "closed" ? colors.primary : "transparent"
                }`,
              fontWeight: activeTab === "closed" ? "bold" : "normal",
              color: activeTab === "closed" ? colors.primary : "white",
              transition: "all 0.3s ease",
            }}
          >
            Closed Tickets
          </div>
        </div>

        {/* Active tickets */}
        {activeTab === "active" && (
          <div style={{ margin: "20px 0px" }}>

            <Table
              key={this.state.version}
              api={URL_PATH.getAllActiveTickets}
              onView={(item) => {
                this.props.history.push(routes.admin.support.detail(this.props.match.params.hotelSlug, item.id));
              }}
              onRowClick={(item) => {
                this.props.history.push(
                  routes.admin.support.detail(
                    this.props.match.params.hotelSlug,
                    item.id
                  )
                );
              }}
              row={[
                {
                  title: "Ticket ID",
                  key: "id",
                },
                {
                  title: "Subject",
                  key: "title",
                },
                {
                  title: "Type",
                  key: "type",
                },
                {
                  title: "Created Date",
                  key: "created_at",
                  parseFunction: (item) => {
                    return moment(item).format("DD-MM-YYYY hh:mm A");
                  },
                },
              ]}
            />
          </div>
        )}

        {/* Closed tickets */}
        {activeTab === "closed" && (
          <div style={{ margin: "20px 0px" }}>

            <Table
              key={this.state.version}
              api={URL_PATH.getTicketsHistory}
               onView={(item) => {
                this.props.history.push(routes.admin.support.detail(this.props.match.params.hotelSlug, item.id));
              }}
              
              row={[
                {
                  title: "Subject",
                  key: "subject",
                },
                {
                  title: "Type",
                  key: "type",
                },
                {
                  title: "Status",
                  key: "status",
                },
                {
                  title: "Created Date",
                  key: "created_at",
                  parseFunction: (item) => {
                    return moment(item).format("DD-MM-YYYY hh:mm A");
                  },
                },
              ]}
            />
          </div>
        )}
      </div>
    );
  }
}

export default redux(CreateScreen);